import http from 'conversations-http/clients/http';
export const fetchGoalsOnboardingData = () => http.get(`cv-goals/v1/onboarding`);